const normalize = (version?: string | null) => (version || '').replace(/[^a-z0-9]/gi, '').toUpperCase();

export const isOrchestratorPipeline = (version?: string | null) =>
  ['ORCHESTRATORV1', 'ORCHESTRATORCSHARPV1'].includes(normalize(version));

export const isCsharpPipelineV2 = (version?: string | null) => normalize(version) === 'CSHARPPIPELINEV2';

export const hasRunMetadata = (version?: string | null) =>
  isCsharpPipelineV2(version) || isOrchestratorPipeline(version);
